<template>
    <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        <div class="kt-portlet kt-portlet--mobile" id="header-div">
            <div class="kt-portlet__head kt-portlet__head--lg no-border-radius">
                <div class="kt-portlet__head-label d-flex justify-content-between" style="width: 100%">
                    <div>
                        <AppWorkAnalyzerFilterBar v-show="!isScreenMobile" @selectedOrg="setSelectedOrg"
                                                  @selectedOperationType="setSelectedOperationType"
                                                  @noOperationsForOrg="setNoOperationsForOrg"
                                                  @clearQueryParams="clearQueryParams"/>
                        <AppButton v-if="isScreenMobile" type="primary" class="mr-2"
                                   @handleClick="openFilterDialog">
                            {{ $t('AppWorkAnalyzer.Filtrar') }}
                        </AppButton>
                    </div>
                    <div>
                        <Button @click="toggle" icon="pi pi-file" aria-haspopup="true" aria-controls="overlay_menu"
                                :label="$t('AppWorkAnalyzer.Exportar')" :disabled="noDataAvailable"/>
                        <Menu id="overlay_menu" ref="menu" appendTo="header-div" :model="menuItems" :popup="true"/>
                    </div>
                </div>
            </div>
            <div v-if="!selectedOrg" class="d-flex justify-content-center mt-5">
                <div class="text-center flex-column kt-font-lg">
                    <div class="font-weight-bold kt-font-xl">
                        {{ $t('AppWorkAnalyzer.Selecione uma organização para visualizar os dados') }}
                    </div>
                </div>
            </div>
            <div v-else-if="noOperationsForOrg" class="d-flex justify-content-center mt-5">
                <div class="text-center flex-column kt-font-lg">
                    <div class="font-weight-bold kt-font-xl">
                        {{ $t('AppWorkAnalyzer.Esta organização não possui operações') }}
                    </div>
                    <div class="mt-2">
                        {{ $t('AppWorkAnalyzer.Selecione outra organização para visualizar os dados') }}
                    </div>
                </div>
            </div>
            <div v-else-if="selectedOperationType" class="kt-portlet__body no-padding">
                <AppWorkAnalyzerFilter :drill-in="drillInString" :operation-type="selectedOperationType"
                                       :query-pivot="queryPivot" :filtersContent="filtersContent"
                                       :all-filters-empty="allFiltersEmpty" @pivotSelected="pivotSelected"
                                       @removeDrillUpTo="removeDrillUpTo" @filterData="filterData"
                                       @updateTableView="updateTableView"/>
                <AppWorkAnalyzerTable ref="table" :data="allData" :pivot="queryPivot" :operation-type="selectedOperationType"
                                      :tableView="tableView" :loading="loading" :selected-org="selectedOrg"
                                      :drill-in-string="drillInString" :all-filters-empty="allFiltersEmpty"
                                      @pivotSelected="pivotSelected" @drillInFilter="drillInFilter"
                                      @clearDataOnError="clearData"/>
            </div>
        </div>

        <Dialog :header="$t('AppWorkAnalyzer.Filtrar')" :visible.sync="showDialogFilter"
                :contentStyle="{width: '85vw', overflow: 'visible'}" modal>
            <AppWorkAnalyzerFilterBar ref="workAnalyzerFilterBar" :dialog="true" @selectedOrg="setSelectedOrg"
                                      @selectedOperationType="setSelectedOperationType"
                                      @noOperationsForOrg="setNoOperationsForOrg"
                                      @clearQueryParams="clearQueryParams"/>
            <template #footer>
                <Button :label="$t('AppWorkAnalyzer.Cancelar')" icon="pi pi-times" class="p-button-text"
                        @click="showDialogFilter = false"/>
                <Button :label="$t('AppWorkAnalyzer.Aplicar')" icon="pi pi-check" class="p-button-text"
                        @click="applySelection"/>
            </template>
        </Dialog>

        <AppWorkAnalyzerReport v-if="selectedOperationType" ref="workAnalyzerReport" :data="pdfAllData" :loading="loading"
                               :query-pivot="queryPivot" :operation-type="selectedOperationType"
                               :drill-in-string="drillInString"/>
    </div>
</template>

<script>

import WorkAnalyzerService from "@/services/WorkAnalyzerService";

import Menu from "primevue/menu";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import Dropdown from "primevue/dropdown";
import AppWorkAnalyzerTable from "./AppWorkAnalyzerTable.vue";
import AppWorkAnalyzerFilter from "./AppWorkAnalyzerFilter.vue";
import AppWorkAnalyzerReport from "./AppWorkAnalyzerReport.vue";
import AppWorkAnalyzerFilterBar from "./AppWorkAnalyzerFilterBar.vue";

import dateFormat from "@/mixins/DateMixin";
import AppButton from "@/components/common/AppButton.vue";

export default {
    mixins: [dateFormat],
    mounted() {
        this.workAnalyzerService = new WorkAnalyzerService();

        this.filter = this.parseDrillIn();
    },
    data() {
        return {
            workAnalyzerService: null,
            selectedOrg: null,
            noOperationsForOrg: false,
            selectedOperationType: null,
            showDialogFilter: false,
            allData: {},
            pdfAllData: {},
            filtersContent: null,
            loading: false,
            filter: null,
            drillInString: '',
            tableView: null,
            menuItems: [
                {
                    label: this.$t('AppWorkAnalyzer.Exportar PDF'),
                    icon: 'pi pi-file-pdf',
                    command: () => this.exportPDF()
                },
                {
                    label: this.$t('AppWorkAnalyzer.Exportar CSV'),
                    icon: 'pi pi-file-excel',
                    command: () => this.$refs.table.exportCSV()
                }
            ]
        }
    },
    methods: {
        setSelectedOrg(selectedOrg) {
            this.selectedOrg = selectedOrg
        },
        setNoOperationsForOrg(noOperationsForOrg) {
            this.noOperationsForOrg = noOperationsForOrg
        },
        setSelectedOperationType(selectedOperationType) {
            this.selectedOperationType = selectedOperationType
        },
        openFilterDialog() {
            this.showDialogFilter = true;
        },
        applySelection() {
            this.$refs.workAnalyzerFilterBar.applySelection();
            this.showDialogFilter = false;
        },
        getSummary() {
            this.loading = true;
            let body = {
                org_id: this.selectedOrg.id,
                pivot: this.queryPivot,
                operation_type: this.selectedOperationType.name
            };

            if (this.filter) {
                body.filters = this.filter;
            }

            switch (this.selectedOperationType.name) {
                case 'LIQUID_APPLICATION':
                    this.getData(body, 'liquid_application');
                    break;
                case 'DRY_APPLICATION':
                    this.getData(body, 'dry_application');
                    break;
                case 'TILLAGE':
                    this.getData(body, 'tillage');
                    break;
                case 'HARVEST':
                    this.getData(body, 'harvest');
                    break;
                case 'MOWING':
                    this.getData(body, 'mowing');
                    break;
                case 'SEEDING':
                    this.getData(body, 'seeding');
                    break;
                case 'TRANSPORT':
                    this.getData(body, 'transport');
                    break;
            }
        },
        getData(body, endpoint) {
            this.workAnalyzerService.getData(this.selectedOrg.id, body, endpoint)
                .then((response) => {
                    if (response.status === 204) {
                        this.clearData();
                        return;
                    }

                    this.allData = response.data
                })
                .catch(() => {
                    this.clearData();
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppWorkAnalyzer.Erro ao recuperar dados da organização'),
                        life: 5000
                    });
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        clearData() {
            this.allData = {
                data: [],
                total: {}
            };
        },
        pivotSelected(pivot) {
            this.updateQueryParams('pivot', pivot);
        },
        updateQueryParams(param, value) {
            let currentParams = this.$route.query;
            let updatedParams = {
                opType: currentParams.opType,
                drillIn: currentParams.drillIn,
                pivot: currentParams.pivot
            };

            if (param === 'opType') {
                updatedParams.opType = value;
                this.$router.replace({...this.$router.currentRoute, query: updatedParams});
                return;
            }

            if (param === 'pivot') {
                if (value.toUpperCase() === this.$route.query.pivot) {
                    return;
                }

                updatedParams.pivot = value.toUpperCase();
                this.$router.replace({...this.$router.currentRoute, query: updatedParams});
                return;
            }

            updatedParams.drillIn = value;
            if (!value) {
                delete updatedParams.drillIn;
            }

            this.$router.replace({...this.$router.currentRoute, query: updatedParams});
        },
        filterData(filter) {
            this.filter = this.buildFilter(filter);
            this.getSummary();
        },
        buildFilter(filter) {
            let drillInFilter = this.parseDrillIn();
            if (Object.keys(filter).length === 0) {
                return drillInFilter;
            }

            let tmpFilter = filter;
            for (const key in drillInFilter) {
                tmpFilter[key] = drillInFilter[key];
            }

            return tmpFilter;
        },
        getFiltersContent() {
            let filters = ['fields', 'operations', 'operators', 'vehicles'];

            switch (this.selectedOperationType.name) {
                case 'LIQUID_APPLICATION':
                case 'DRY_APPLICATION':
                    filters.push('products');
                    break;
                case 'HARVEST':
                case 'MOWING':
                case 'SEEDING':
                    filters.push('varieties');
                    break;
                case 'TRANSPORT':
                    break;
            }

            let promises = [];
            filters.forEach(filter => {
                promises.push(this.workAnalyzerService.getFilterList(this.selectedOrg.id, this.selectedOperationType.name, filter));
            })

            Promise.all(promises)
                .then(async (results) => {
                    this.parseFiltersResponse(results, filters);
                })
                .catch(() => {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppWorkAnalyzer.Erro ao recuperar filtros'),
                        life: 5000
                    });
                })
                .finally(() => {
                    let jsonFilters = JSON.stringify(this.filtersContent);
                    if (jsonFilters.includes(this.queryPivot)) {
                        this.getSummary();
                    }
                });
        },
        parseFiltersResponse(results, filters) {
            let responses = [];
            for (const res in results) {
                let values = results[res].status === 204 ? [] : results[res].data.data
                if (filters[res] === 'operations' && values.length > 0) {
                    values = this.formatOperationsFilterDate(values);
                }
                responses.push({id: filters[res], values: values});
            }

            this.filtersContent = responses;
        },
        formatOperationsFilterDate(values) {
            let formattedValues = [];
            values.forEach(value => {
                let start_end = value.label.split(' - ');
                let start = this.dateFormat(new Date(start_end[0] * 1000) / 1000, 'GMT');
                let end = this.dateFormat(new Date(start_end[1] * 1000) / 1000, 'GMT');
                formattedValues.push({id: value.id, label: `${start} - ${end}`});
            })
            return formattedValues;
        },
        clearQueryParams() {
            this.filter = null;
            this.drillInString = '';
            this.$router.replace({...this.$router.currentRoute, query: {}});
        },
        parseDrillIn() {
            if (!this.$route.query.drillIn) {
                return null;
            }

            this.drillInString = this.$route.query.drillIn;
            let drillInList = this.drillInString.toLowerCase().split(';');
            let tmpFilter = {}
            drillInList.forEach(drill => {
                let key_value = drill.split(':');
                tmpFilter[key_value[0]] = [key_value[1]];
            })

            return tmpFilter;
        },
        drillInFilter(selection) {
            if (!this.filter) {
                this.filter = {}
            }

            this.filter[selection.key] = [selection.value];

            if (this.drillInString.length > 0) {
                this.drillInString += ';'
            }
            this.drillInString += `${selection.key.toUpperCase()}:${selection.value}`;

            this.updateQueryParams('drillIn', this.drillInString);
        },
        removeDrillUpTo(selectionKey) {
            this.pivotSelected(selectionKey.toLowerCase());
            let drillList = this.drillInString.split(';')

            if (drillList[0].includes(selectionKey)) {
                this.clearDrillIn(drillList);
                return;
            }

            let newDrillIn = drillList[0];
            let index = 0;
            do {
                let drill = drillList[index];
                if (!newDrillIn.includes(drill)) {
                    newDrillIn += `;${drill}`;
                }
                index++;
            } while (!drillList[index].includes(selectionKey));

            let drillInKeys = drillList.map(item => item.split(':')[0].toLowerCase());
            for (const key of drillInKeys.slice(index, drillInKeys.length)) {
                delete this.filter[key];
            }

            this.drillInString = newDrillIn;
            this.updateQueryParams('drillIn', this.drillInString);
        },
        clearDrillIn(drillList) {
            drillList.forEach(drill => {
                let key_value = drill.toLowerCase().split(':');
                delete this.filter[key_value[0]];
            })

            this.drillInString = '';
            this.updateQueryParams('drillIn', null);
        },
        updateTableView(view) {
            this.loading = true;
            this.tableView = view;
            setTimeout(() => this.loading = false, 5);
        },
        toggle(event) {
            this.$refs.menu.toggle(event);
        },
        exportPDF() {
            this.$refs.workAnalyzerReport.generateReport();
        }
    },
    watch: {
        selectedOperationType: function () {
            if (!this.selectedOperationType) {
                return;
            }

            if (this.queryOpType !== this.selectedOperationType.group) {
                this.updateQueryParams('opType', this.selectedOperationType.group)
            }
            this.loading = true;
            this.getFiltersContent();
        },
        queryPivot: function () {
            setTimeout(() => this.getSummary(), this.loading ? 10 : 0);
        },
        allData: function () {
            this.pdfAllData = JSON.parse(JSON.stringify(this.allData));
        }
    },
    computed: {
        queryPivot: function () {
            if (!this.$route.query.pivot) {
                this.updateQueryParams('pivot', 'fields')
            }
            return this.$route.query.pivot.toLowerCase();
        },
        queryOpType: function () {
            if (!this.$route.query.opType) {
                return null;
            }
            return parseInt(this.$route.query.opType)
        },
        allFiltersEmpty: function () {
            if (!this.filtersContent) {
                return true;
            }

            let allEmpty = true;
            for (const filter of this.filtersContent) {
                if (filter.values.length > 0) {
                    allEmpty = false;
                }
            }

            return allEmpty;
        },
        noDataAvailable: function () {
            if (!this.allData.data) {
                return true;
            }

            return this.allData.data.length === 0 || Object.keys(this.allData.total).length === 0;
        },
        isScreenMobile: function () {
            return window.screen.width <= 1024;
        }
    },
    components: {
        Dialog,
        AppButton,
        Dropdown, Button, Menu, AppWorkAnalyzerTable, AppWorkAnalyzerFilter, AppWorkAnalyzerReport, AppWorkAnalyzerFilterBar}
}
</script>

<style>

</style>
